'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.silenceErrorAlert = undefined;

var _buildErrorMetaObject = require('./buildErrorMetaObject');

var silenceErrorAlert = exports.silenceErrorAlert = function silenceErrorAlert() {
  return (0, _buildErrorMetaObject.buildErrorMetaObject)({ silent: true });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/lib/silenceErrorAlert.js
// module id = 823
// module chunks = 2 3